import { StateIdType } from "@containers/PayPerLead/interface/Actions";
import { Discount, SubscriptionStatus } from "@shared/models";

export interface SubscriptionServerModel {
  id?: number;
  price?: number;
  is_paused?: boolean;
  account_id?: number;
  created_at?: Date | string;
  updated_at?: Date | string;
  activated_at?: Date | string;
  cancelled_at?: Date | string;
  next_billing_at?: Date | string;
  status?: SubscriptionStatus;
  start_date?: Date;
  end_date?: Date;
  is_active?: boolean;
  renew?: boolean;
  draft?: {
    id: number;
  };
  items: SubscriptionItemServerModel[];
  coupon?: string;
  lock?: {
    created_at?: Date | string;
  };
  remaining_balance?: number;
  discounts?: Discount[];
}

export interface SubscriptionItemServerModel {
  state_id?: number | StateIdType;
  leads_total: number;
  unassigned_leads?: number;
  all_counties: boolean;
  all_states?: boolean;
  price?: number;
  counties: { id: number; name: string }[];
  paid_amount?: number;
}

export enum LeadErrorReason {
  invalidNumber = "INVALID_PHONE",
  invalidEmail = "INVALID_EMAIL",
  activeListing = "LEAD_ON_MLS",
  unacceptablePropertyType = "UNACCEPTABLE_LEAD_PROPERTY_TYPE",
  leadExists = "LEAD_EXISTS",
  noCoverage = "LEAD_NO_COVERAGE",
  addressNotFound = "LEAD_ADDRESS_NOT_FOUND",
  buyerRejected = "BUYER_REJECTED",
}
